import request from "@/utiles/axios";

/**
 * 分页条件查询
 * @param {*} data
 * @returns
 */
export function getDataCorrPageList(data) {
    return request({
      url: "/pc/dataCorrection/pageList",
      method: "post",
      data: data,
    });
}

/**
 * 查询待修正数据
 * @param data
 * @returns {*}
 */
export function getCorrectionData(data) {
    return request({
        url: "/pc/dataCorrection/getCorrectionData",
        method: "post",
        data: data,
    });
}

/**
 * 修正数据
 * @param data
 * @returns {*}
 */
export function correct(data) {
    return request({
        url: "/pc/dataCorrection/correct",
        method: "post",
        data: data,
    });
}

